<template>
  <div class="integral-view">
    <p>{{ orderInfo.orderNo }}</p>
    <div class="view-main">
      <a-spin :spinning="loading">
        <div class="view-head">
          <div class="head-rig">
            <Nav label="订单信息" :is-class="false"></Nav>
            <div class="rig-main">
              <div class="main-top">
                <div class="rig-item">
                  <p>订单编码：</p>
                  <p>{{ orderInfo.orderNo }}</p>
                </div>
                <div class="rig-item">
                  <p>创建时间：</p>
                  <p>{{ orderInfo.createdAt }}</p>
                </div>
                <div class="rig-item">
                  <p>更新时间：</p>
                  <p>
                    {{ orderInfo.updatedAt }}
                  </p>
                </div>
                <div class="rig-item">
                  <p>订单状态：</p>
                  <p class="color">
                    {{ orderInfo.enumStatus }}
                  </p>
                </div>
                <div class="rig-item">
                  <p>卖家姓名：</p>
                  <p>{{ orderInfo.userName }}</p>
                </div>
                <div class="rig-item">
                  <p>联系电话：</p>
                  <p>{{ orderInfo.cellPhone }}</p>
                </div>
              </div>

              <div class="main-bot">
                <div class="rig-item">
                  <p>支付方式：</p>
                  <p>{{ orderInfo.paymentType }}</p>
                </div>
                <div class="rig-item">
                  <p>支付时间：</p>
                  <p>{{ orderInfo.completedAt }}</p>
                </div>
                <div class="rig-item">
                  <p>卖家报价：</p>
                  <p> ￥0 </p>
                </div>
                <div class="rig-item">
                  <p>质检价：</p>
                  <p> {{ order.inspectionAmount }} </p>
                </div>

                <div class="rig-item">
                  <p>优惠金额：</p>
                  <p> {{ order.coopCouponPrice }} </p>
                </div>

                <div class="rig-item">
                  <p>合作方补贴：</p>
                  <p> {{ order.coopSubsidy }} </p>
                </div>

                <div class="rig-item">
                  <p>成交价格：</p>
                  <p class="color-blue">
                    {{ order.finalAmount }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="view-item">
          <Nav label="商品信息"></Nav>
          <div class="table">
            <a-table
              :columns="columns"
              :data-source="tableData"
              :row-key="record => record.id"
              class="table-content"
              bordered
            >
              <template slot="mainPath" slot-scope="mainPath">
                <img :src="mainPath">
              </template>
            </a-table>
          </div>
        </div>

        <div class="view-bottom">
          <a-button type="primary" small @click="goback">
            返回
          </a-button>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import Nav from '../../components/nav'
import { getGoodsDetails } from '@/api/transacManage'
import { unixToDate } from '@/utils/formatDate'
const columns = [
  {
    title: '商品品牌',
    key: 'brandNname',
    dataIndex: 'brandNname',
    align: 'center'
  },

  {
    title: '商品类目',
    key: 'categoryName',
    dataIndex: 'categoryName',
    align: 'center'
  },
  {
    title: '商品介绍',
    key: 'skuName',
    dataIndex: 'skuName',
    align: 'center'
  },
  {
    title: '数量',
    key: 'ee',
    dataIndex: 'ee',
    customRender: () => 1,
    align: 'center'
  }
]
export default {
  components: {
    Nav
  },
  data () {
    return {
      /**
       * 商品信息
       */
      columns,
      tableData: [],
      loading: false,
      /**
       * 订单信息
       */
      orderInfo: {
        completedAt: null, // 支付时间
        orderNo: '', // 订单编号
        submitedAmount: 0, // 报价
        brandNname: '', // 品牌
        userName: '', // 卖家名
        categoryName: '', // 分组(分类)
        paymentType: undefined, // 支付方式
        skuName: '', // 商品介绍
        createdAt: undefined, // 创建时间
        inspectionAmount: undefined, // 质检价
        finalAmount: null, // 成交价
        enumStatus: undefined, // 订单状态
        coopCouponPrice: undefined, // 优惠金额
        cellPhone: '', // 卖家手机号
        coopSubsidy: '', // 合作方补贴
        updatedAt: undefined // 更新时间
      }
    }
  },
  computed: {
    order () {
      if (this.orderInfo.inspectionAmount) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.orderInfo.inspectionAmount = '￥' + this.orderInfo.inspectionAmount
      }
      if (this.orderInfo.coopCouponPrice) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.orderInfo.coopCouponPrice = '￥' + this.orderInfo.coopCouponPrice
      }
      if (this.orderInfo.coopSubsidy) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.orderInfo.coopSubsidy = '￥' + this.orderInfo.coopSubsidy
      }
      if (this.orderInfo.finalAmount) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.orderInfo.finalAmount = '￥' + this.orderInfo.finalAmount
      }
      return this.orderInfo
    }
  },
  created () {
    this.getGoodsDetails()
  },
  methods: {
    // 获取详情数据
    async getGoodsDetails () {
      this.loading = true
      try {
        const res = await getGoodsDetails({ id: this.$route.query.id })
        if (res.code === 0) {
          this.orderInfo = res.result
          this.state(this.orderInfo.state)
          this.paymentType(this.orderInfo.paymentType)
          this.enumStatus(this.orderInfo.enumStatus)
          this.orderInfo.createdAt = unixToDate(this.orderInfo.createdAt)
          this.orderInfo.updatedAt = unixToDate(this.orderInfo.updatedAt)
          this.tableData.push(res.result)
        }
      } finally {
        this.loading = false
      }
    },
    goback () {
      this.$router.replace('/catRecycling/DigitalRecycling/transacManage')
    },
    state (text) {
      switch (text) {
        case 0:
          this.orderInfo.state = '待付款'
          break
        case 1:
          this.orderInfo.state = '付款完成'
          break
        case 2:
          this.orderInfo.state = '卖家入库'
          break
        case 4:
          this.orderInfo.state = '租赁中'
          break
        case 5:
          this.orderInfo.state = '超时'
          break
        case 6:
          this.orderInfo.state = '买家取货'
          break
        case 7:
          this.orderInfo.state = '完成'
          break
        case 8:
          this.orderInfo.state = '取消'
          break
        case 9:
          this.orderInfo.state = '退款中'
          break
        case 10:
          this.orderInfo.state = '退款完成'
          break
        case 11:
          this.orderInfo.state = '退款拒绝'
          break
        case 12:
          this.orderInfo.state = '卖家取消'
          break
        case 13:
          this.orderInfo.state = '买家取消'
          break
        case 14:
          this.orderInfo.state = '失效'
          break
        default:
          break
      }
    },
    paymentType (text) {
      switch (text) {
        case 1:
          this.orderInfo.paymentType = '现金'
          break
        case 6:
          this.orderInfo.paymentType = '银行卡'
          break
        case 11:
          this.orderInfo.paymentType = '优惠券'
          break
        case 14:
          this.orderInfo.paymentType = '微信'
          break
        case 15:
          this.orderInfo.paymentType = '钱包'
          break
        case 16:
          this.orderInfo.paymentType = '支付宝'
          break
        default:
          break
      }
    },
    enumStatus (text) {
      switch (text) {
        case 1:
          this.orderInfo.enumStatus = '审核确认'
          break
        case 2:
          this.orderInfo.enumStatus = '待门店验货'
          break
        case 4:
          this.orderInfo.enumStatus = '待派单'
          break
        case 8:
          this.orderInfo.enumStatus = '待上门'
          break
        case 16:
          this.orderInfo.enumStatus = '审核确认'
          break
        case 32:
          this.orderInfo.enumStatus = '待用户发货'
          break
        case 64:
          this.orderInfo.enumStatus = '待商家收货'
          break
        case 128:
          this.orderInfo.enumStatus = '待验货'
          break
        case 192:
          this.orderInfo.enumStatus = '待确认费用'
          break
        case 256:
          this.orderInfo.enumStatus = '验货失败'
          break
        case 260:
          this.orderInfo.enumStatus = '已过期'
          break
        case 512:
          this.orderInfo.enumStatus = '部分退款待确认'
          break
        case 1024:
          this.orderInfo.enumStatus = '全额退款待确认'
          break
        case 2048:
          this.orderInfo.enumStatus = '部分退款拒绝'
          break
        case 4096:
          this.orderInfo.enumStatus = '待退货'
          break
        case 8192:
          this.orderInfo.enumStatus = '待用户收货'
          break
        case 16384:
          this.orderInfo.enumStatus = '支付中'
          break
        case 32768:
          this.orderInfo.enumStatus = '待放款（快递订单用）'
          break
        case 65536:
          this.orderInfo.enumStatus = '交易成功'
          break
        case 131072:
          this.orderInfo.enumStatus = '交易失败'
          break
        default:
          break
      }
    }
  }
}

</script>
<style lang='less' scoped>
.integral-view{
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
  .ant-timeline-item{
    padding-bottom: 5px;
    p{
      margin-bottom: 5px;
    }
    // /deep/ .ant-timeline-item-tail{
    //   border-left-color: #1890ff;
    // }
  }
  .view-main{
    width: 100%;
    display: flex;
    flex-direction: column;

    .view-head{
      width: 100%;
      display: flex;
      .ant-steps-vertical{
        max-height: 40vh;
        overflow: auto;
      }
      /deep/ .ant-steps-item-icon{
        margin-left: 3px;
      }
      /deep/ .ant-steps-item-tail::after{
        margin-left: 15px;
      }
      /deep/ .ant-steps-item-process,/deep/ .ant-steps-item-wait {
        >.ant-steps-item-container > .ant-steps-item-tail::after {
          background: #aaa;
        }
      }
      /deep/ .ant-steps-item-title, /deep/ .ant-steps-item-content{
        width: 220px;
      }
      /deep/ .ant-steps-item-subtitle{
        display: block;
        margin-left: 0;
      }

      /* 设置滚动条的样式 */
      .ant-steps-vertical::-webkit-scrollbar {
        width:8px;
      }

      /* 滚动条滑块 */
      .ant-steps-vertical::-webkit-scrollbar-thumb {
        border-radius:10px;
        background:rgba(0,0,0,0.1);
      }

      .head-lef,.head-rig {
        border: 1px solid #eee;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .head-lef{
        flex: 1;
        min-width: 300px;
      }
      .head-rig{
        flex: 5;
        display: flex;
        flex-direction: column;
        .rig-main{
          flex: 1;
          padding: 0 30px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          .main-top,.main-bot{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            justify-items: center;
            border-bottom: 1px solid #eee;

          }
          .main-bot{
            border: 0;
            margin-top: 20px;
          }
          .rig-item{
            width: 100%;
            display: flex;
            >p:nth-child(1) {
              width: 160px;
              min-width: 160px;
              text-align: right;
            }
            >p:nth-child(2) {
              margin-left: 20px;
            }
            .color{
              color: rgb(255, 153, 0);
            }
            .color-blue{
              color: rgb(0, 121, 254);
            }
          }
        }
      }
    }
  }
  .avatar-img{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    >img{
      width: 60px ;
      height: auto;
      display: block;
      border-radius: 50%;
    }
  }
  .view-bottom{
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  .view-item:nth-child(2){
    margin: 20px 0;
  }
  /deep/ .ant-table-pagination{
    display: none;
  }
  /deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td{
    padding: 0 !important;
  }
}
</style>

<style lang="stylus" scoped>
.dlMain
    width: 1
</style>
